import {Institution} from "../institution.model";
import {InstutionRole} from "../../../instution-settings/instution-role/instution-role.model";
import {Designation} from "../../../instution-settings/designation/designation.model";

export interface InstitutionAdmin {
  id?: string;
  profile?:AdminProfile;
  adminInstitution?: Institution;
  role?:InstutionRole;
  userDesignation?: Designation;
}

export enum UserTypeInum {
  CIT = "CIT",
  INST = "INST",
  POPSM = "POPSM",
  Executive = "Executive",
}

export enum RequestedUserEnumType {
  COMPANY = "COMPANY",
  CITIZEN = "CITIZEN",
}

export interface AdminProfile{
  id?:string;
  profileUniqueId?:string;
  userFirstName?:string;
  userLastName?:string;
  userEmail?:string;
  profilePhone?:string;
  profileIsDeactivated?: boolean;
  profileTitle?:string;
  profilePhoto?:string;
  profileType?:UserTypeInum;
}
